__turbopack_context__.v({
  "audioPlayerWrapper": "contentcardmodal-module-scss-module__IeBTNa__audioPlayerWrapper",
  "body": "contentcardmodal-module-scss-module__IeBTNa__body",
  "cardLink": "contentcardmodal-module-scss-module__IeBTNa__cardLink",
  "content": "contentcardmodal-module-scss-module__IeBTNa__content",
  "copyright": "contentcardmodal-module-scss-module__IeBTNa__copyright",
  "eyebrow": "contentcardmodal-module-scss-module__IeBTNa__eyebrow",
  "imageContainer": "contentcardmodal-module-scss-module__IeBTNa__imageContainer",
  "title": "contentcardmodal-module-scss-module__IeBTNa__title",
  "videoContainer": "contentcardmodal-module-scss-module__IeBTNa__videoContainer",
});
